import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cartActions } from '../reducers/storeCart';
import * as types from '../types';

/**
 * Captures Facebook click ID (fbclid) from URL parameters and stores in Redux.
 * Facebook ad links include ?fbclid=xxx to identify the ad click source.
 * We construct the _fbc value ourselves (fb.1.{timestamp}.{fbclid}) so that
 * analytics-backend can attribute conversions via Meta Conversions API even when
 * fbevents.js doesn't load (ad blockers, no consent, Safari ITP).
 *
 * @see https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
 */
export function FacebookClickCapture(): null {
  const dispatch = useDispatch();
  const cart = useSelector((state: types.AppState) => state.storeShop.cart);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    if (fbclid) {
      // Construct _fbc format: fb.{subdomainIndex}.{creationTime}.{fbclid}
      const fbc = `fb.1.${Date.now()}.${fbclid}`;
      if (fbc !== cart.facebookClick) {
        dispatch(cartActions.setFacebookClick(fbc));
      }
    }
  }, [dispatch, cart.facebookClick]);

  return null;
}
